<template>
  <div class="screen screen__contact" v-loading="!page.title">
    <page-banner :heading="page.title" :sub-heading="page.subheading" />

    <el-container direction="vertical" class="page--container">
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <about-menu />
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <section class="page--section">
            <div v-html="page.overview"></div>
          </section>
        </el-col>
      </el-row>
    </el-container>
    <footer-main />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import singles from '@/components/singles';
import PageBanner from '@/components/PageBanner.vue';
import AboutMenu from '@/screens/about/AboutMenu.vue';
import FooterMain from '@/components/footer/FooterMain.vue';

export default {
  name: 'HelpPage',
  data() {
    return {
      page: {}
    };
  },
  props: {
    handle: String,
  },
  components: {
    PageBanner,
    AboutMenu,
    FooterMain,
  },
  methods: {
    ...mapActions(singles.store.namespace, ['getPage']),
    loadPage,
  },
  watch: {
    handle: function (newHandle, oldHandle) {
      this.loadPage();
    }
  },
  beforeMount: loadPage,
}

function loadPage() {
  if (this.handle) {
    this.getPage(this.handle).then(p => this.page = p);
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.screen__contact {
  .el-row {
    background-color: $--color-white;
  }
}
</style>

